import { api } from '../../../../../../../lib';
import { EditRuleCompetitorsApi } from './EditCompetitors.types';
import { PARSE_RAW_RESPONSE } from './EditRuleCompetitorsModalTable';

type StoredClient = { codigo?: string | number | null };
const getStoredClientCode = (): string => {
  try {
    const raw = localStorage.getItem('cliente');
    if (!raw) return '';
    const parsed = JSON.parse(raw) as StoredClient;
    return parsed?.codigo != null ? String(parsed.codigo) : '';
  } catch {
    return '';
  }
};

const normalizeIds = (ids?: string[]) => (Array.isArray(ids) ? ids : []);

export const GET_EDIT_COMPETITORS_MODAL_DATA = async (
  params: {
    sort: string;
    size: number;
    page: number;
  },
  data: { storeId?: string[]; clusterId?: string[] },
): Promise<EditRuleCompetitorsApi['response']> => {
  const payload = {
    client: getStoredClientCode(),
    storeId: normalizeIds(data.storeId),
    clusterId: normalizeIds(data.clusterId),
  };

  const response = await api.post<EditRuleCompetitorsApi['rawResponse']>('/competitors/rule/stores', payload, {
    expectToken: true,
    params,
  });
  return PARSE_RAW_RESPONSE(response.data);
};
